import { useContext } from "react";
import { NodeMembershipContext, NodeMembershipContextValue } from "src/contexts";

function useNodeMembership(): NodeMembershipContextValue {
    return useContext(NodeMembershipContext);
}

export default useNodeMembership;
